import { Dialog, DialogContentProps } from '@chakra-ui/react';
import React, { ReactElement } from 'react';
import { ModalTarget } from 'types/Modal';

type Props = DialogContentProps & {
  isFullscreen?: boolean;
  placement?: 'center' | 'top' | 'bottom' | 'left' | 'right';
  target?: ModalTarget;
};

export const CustomModalContent = ({ isFullscreen, ...props }: Props): ReactElement => {
  return (
    <Dialog.Content style={isFullscreen ? { margin: '0px', padding: '0px' } : undefined} {...props}>
      {props.children}
    </Dialog.Content>
  );
};
